import {TenderStatus} from '@frontend/shared-api';

export type TagSeverity = 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast';

export class TenderStatusUtils {
  private static readonly STATUS_SEVERITY_MAP: Partial<Record<TenderStatus, TagSeverity>> = {
    [TenderStatus.INVITED]: 'warn',
    [TenderStatus.ACCEPTED]: 'info',
    [TenderStatus.PREPARED]: 'info',
    [TenderStatus.FINISHED]: 'success',
    [TenderStatus.WON]: 'success',
    [TenderStatus.WAITING_FOR_CUSTOMER]: 'warn',
    [TenderStatus.REJECTED]: 'danger',
    [TenderStatus.EXPIRED]: 'danger',
    [TenderStatus.LOST]: 'danger',
    [TenderStatus.UNSET]: 'secondary',
  };

  private static readonly FINAL_STATUSES: ReadonlySet<TenderStatus> = new Set([
    TenderStatus.FINISHED,
    TenderStatus.WON,
    TenderStatus.WAITING_FOR_CUSTOMER,
    TenderStatus.REJECTED,
    TenderStatus.EXPIRED,
    TenderStatus.LOST,
  ]);

  public static getStatusSeverity(status: TenderStatus): TagSeverity {
    return this.STATUS_SEVERITY_MAP[status] ?? 'secondary';
  }

  public static canEditDecision(status?: TenderStatus): boolean {
    return status === TenderStatus.INVITED;
  }

  public static canEditQuestionnaire(status?: TenderStatus): boolean {
    return status === TenderStatus.ACCEPTED || status === TenderStatus.PREPARED;
  }

  public static canHaveDecisionReason(status: TenderStatus): boolean {
    return (
      status === TenderStatus.FINISHED ||
      status === TenderStatus.WON ||
      status === TenderStatus.WAITING_FOR_CUSTOMER ||
      status === TenderStatus.LOST ||
      status === TenderStatus.EXPIRED
    );
  }

  public static isFinalStatus(status?: TenderStatus): boolean {
    return !!status && this.FINAL_STATUSES.has(status);
  }

  public static isNegativeOutcome(status: TenderStatus): boolean {
    return (
      status === TenderStatus.LOST ||
      status === TenderStatus.REJECTED ||
      status === TenderStatus.EXPIRED
    );
  }
}
